import React, { ReactElement, useEffect, useRef } from 'react';

interface OutsideClickDetectorProps {
  callback: () => void;
  children: ReactElement;
  detectEscape?: boolean;
  delayMs?: number;
}

const OutsideClickDetector = (props: OutsideClickDetectorProps) => {
  const {
    callback,
    children,
    detectEscape = true,
    delayMs = 100,
  } = props;

  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as HTMLDivElement)) {
        callback();
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        callback();
      }
    };

    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
      if (detectEscape) {
        document.addEventListener('keydown', handleKeyDown);
      }
    }, delayMs);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      if (detectEscape) {
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [wrapperRef, callback]);

  return <div ref={ wrapperRef }>{ children }</div>;
};

export default OutsideClickDetector;
